// BottomNav.jsx
import { NavLink, useLocation } from 'react-router-dom';
import {
    HomeIcon, CalendarDaysIcon, PlusCircleIcon,
    WrenchScrewdriverIcon, HeartIcon,
} from '@heroicons/react/24/solid';

export default function BottomNav() {
    const location = useLocation();

    const menus = [
        { to: '/dashboard', label: '메인', icon: HomeIcon, alsoActiveOn: ['/profile', '/healthsurvey', '/todos'] },
        { to: '/schedule', label: '운동 스케줄', icon: CalendarDaysIcon, alsoActiveOn: ['/schedule/day'] },
        { to: '/workout', label: '운동', icon: PlusCircleIcon, alsoActiveOn: ['/workout/', '/workout/results', '/workout/cardio-endurance'] },
        { to: '/machine', label: '머신 설정', icon: WrenchScrewdriverIcon },
        { to: '/health/bp', label: '건강 관리', icon: PlusCircleIcon, alsoActiveOn: ['/health/weight', '/health/detail', '/health/bp', '/health/glucose'] },
    ];

    const isAlsoActive = (paths = []) =>
        paths.some((p) => location.pathname.startsWith(p));

    return (
        <nav className="fixed bottom-0 left-0 w-full bg-white border-t shadow-sm
                    md:max-w-[768px] md:left-1/2 md:-translate-x-1/2">
            <ul className="grid grid-cols-5 divide-x divide-gray-200">
                {menus.map(({ to, label, icon: Icon, alsoActiveOn }) => (
                    <li key={to}>
                        <NavLink
                            to={to}
                            end                     // <- 그대로 두어도 아래 OR 조건으로 활성화됨
                            className={({ isActive }) =>
                                `flex flex-col items-center justify-center py-4 gap-0.5 text-xs
                                ${(isActive || isAlsoActive(alsoActiveOn)) ? 'text-blue-500' : 'text-gray-400'}`
                            }
                        >
                            <Icon className="w-8 h-8" />
                            {label}
                        </NavLink>
                    </li>
                ))}
            </ul>
        </nav>
    );
}
